<template>
  <div class="profile-wrapper">
    <div class="inner-profile">
      <!-- REFERRAL CODE SECTION -->
      <section class="info-card mb-4">
        <div class="card-header-custom">
          <i class="fa fa-gift mr-2"></i>
          <h5 class="mb-0">Mã giới thiệu</h5>
        </div>
        <div class="card-body-custom">
          <div class="form-group mb-0">
            <input
              v-model="referralCode"
              class="form-control form-control-custom"
              placeholder="Nhập mã giới thiệu"
              :disabled="hasReferralCode"
            />
            <div class="error-message" v-if="!hasReferralCode && referralMsg">
              {{ referralMsg }}
            </div>
          </div>

          <button
            v-if="!hasReferralCode"
            class="btn btn-primary btn-custom mt-3"
            :disabled="loadingReferral"
            @click="updateReferral"
          >
            <i class="fa fa-check mr-2"></i>
            Cập nhật mã
          </button>

          <div v-else class="success-badge mt-3">
            <i class="fa fa-check-circle mr-2"></i>
            Đã có mã giới thiệu
          </div>
        </div>
      </section>

      <!-- PERSONAL INFO SECTION -->
      <section class="info-card mb-4">
        <div class="card-header-custom">
          <i class="fa fa-user-circle mr-2"></i>
          <h5 class="mb-0">Thông tin cá nhân</h5>
        </div>
        <div class="card-body-custom">
          <div class="form-group">
            <label class="form-label-custom require">
              <i class="fa fa-id-card text-primary mr-2"></i>
              {{ $t('label.name') }}
            </label>
            <b-form-input
              v-model="profile.fullName"
              class="form-control-custom"
            />
            <div class="error-message">{{ profileMsg.fullName?.[0] }}</div>
          </div>

          <div class="form-group">
            <label class="form-label-custom">
              <i class="fa fa-calendar text-primary mr-2"></i>
              {{ $t('label.dob') }}
            </label>
            <datepicker
              v-model="profile.dob"
              :format="format"
              input-class="form-control form-control-custom"
            />
          </div>

          <div class="form-group">
            <label class="form-label-custom require">
              <i class="fa fa-phone text-primary mr-2"></i>
              {{ $t('label.phoneNumber') }}
            </label>
            <input
              type="number"
              v-model="profile.phoneNumber"
              class="form-control form-control-custom"
            />
            <div class="error-message">
              {{ profileMsg.phoneNumber?.[0] }}
            </div>
          </div>

          <div class="form-group mb-0">
            <label class="form-label-custom">
              <i class="fa fa-envelope text-primary mr-2"></i>
              {{ $t('label.email') }}
            </label>
            <b-form-input
              v-model="profile.email"
              class="form-control-custom"
            />
            <div class="error-message">
              {{ profileMsg.messageEmail?.[0] }}
            </div>
          </div>
        </div>
      </section>

      <!-- ACTION BUTTONS -->
      <div class="action-group">
        <button class="btn btn-outline-secondary btn-custom" @click="backToDashboard">
          <i class="fa fa-arrow-left mr-2"></i>
          {{ $t('label.back') }}
        </button>

        <button class="btn btn-danger btn-custom" @click="openPasswordModal">
          <i class="fa fa-lock mr-2"></i>
          Đổi mật khẩu
        </button>
      </div>
    </div>

    <!-- PASSWORD MODAL -->
    <b-modal
      id="password-modal"
      centered
      hide-footer
      title="Đổi mật khẩu"
      modal-class="custom-modal"
    >
      <div class="form-group">
        <label class="form-label-custom">
          <i class="fa fa-lock text-primary mr-2"></i>
          Mật khẩu hiện tại
        </label>
        <input
          type="password"
          v-model="password.old"
          class="form-control form-control-custom"
          placeholder="Nhập mật khẩu hiện tại"
        />
      </div>

      <div class="form-group">
        <label class="form-label-custom">
          <i class="fa fa-key text-primary mr-2"></i>
          Mật khẩu mới
        </label>
        <input
          type="password"
          v-model="password.new"
          class="form-control form-control-custom"
          placeholder="Nhập mật khẩu mới"
        />
      </div>

      <div class="form-group">
        <label class="form-label-custom">
          <i class="fa fa-check-circle text-primary mr-2"></i>
          Xác nhận mật khẩu mới
        </label>
        <input
          type="password"
          v-model="password.confirm"
          class="form-control form-control-custom"
          placeholder="Nhập lại mật khẩu mới"
        />
      </div>

      <div class="error-message" v-if="passwordMsg">{{ passwordMsg }}</div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <button
          class="btn btn-outline-secondary btn-custom"
          @click="$bvModal.hide('password-modal')"
        >
          Hủy
        </button>
        <button
          class="btn btn-danger btn-custom"
          :disabled="loadingPassword"
          @click="confirmChangePassword"
        >
          <i class="fa fa-check mr-2"></i>
          Xác nhận
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import apiClient from '@/axios'
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'

export default {
  components: { Datepicker },

  data() {
    return {
      format: 'dd/MM/yyyy',

      profile: {},
      profileMsg: {},

      referralCode: '',
      originalReferralCode: null,
      referralMsg: '',
      loadingReferral: false,

      password: {
        old: '',
        new: '',
        confirm: ''
      },
      passwordMsg: '',
      loadingPassword: false
    }
  },

  computed: {
    hasReferralCode() {
      return !!this.originalReferralCode
    }
  },

  mounted() {
    this.getUserInfo()
  },

  watch: {
    referralCode(val) {
      if (!val) return
      const upper = val.toUpperCase()
      if (upper !== val) {
        this.referralCode = upper
      }
    }
  },

  methods: {
    async getUserInfo() {
      const res = await apiClient.get('/api/v1/sale/info')
      this.profile = res.data

      if (res.data.referralCode) {
        this.referralCode = res.data.referralCode
        this.originalReferralCode = res.data.referralCode
      } else {
        this.referralCode = ''
        this.originalReferralCode = null
      }
    },

    async updateReferral() {
      if (!this.referralCode) {
        this.referralMsg = 'Vui lòng nhập mã giới thiệu'
        return
      }

      this.loadingReferral = true
      this.referralMsg = ''

      try {
        await apiClient.post('/api/v1/sale/referral-code', {
          referral_code: this.referralCode
        })

        this.originalReferralCode = this.referralCode

        this.$bvToast.toast('Cập nhật mã giới thiệu thành công', {
          variant: 'success',
          solid: true
        })
      } catch (e) {
        this.referralMsg = e.response?.data?.message || 'Có lỗi xảy ra'
      } finally {
        this.loadingReferral = false
      }
    },

    openPasswordModal() {
      this.passwordMsg = ''
      this.password = { old: '', new: '', confirm: '' }
      this.$bvModal.show('password-modal')
    },

    async confirmChangePassword() {
      this.passwordMsg = ''

      if (!this.password.old || !this.password.new || !this.password.confirm) {
        this.passwordMsg = 'Vui lòng nhập đầy đủ thông tin'
        return
      }

      if (this.password.new !== this.password.confirm) {
        this.passwordMsg = 'Mật khẩu xác nhận không khớp'
        return
      }

      this.loadingPassword = true
      try {
        await apiClient.post('/api/v1/auth/change-password', {
          oldPassword: this.password.old,
          newPassword: this.password.new,
          confirmPassword: this.password.confirm
        })

        this.$bvToast.toast('Đổi mật khẩu thành công', {
          variant: 'success',
          solid: true
        })

        this.$bvModal.hide('password-modal')
      } catch (e) {
        this.passwordMsg =
          e.response?.data?.message || 'Đổi mật khẩu thất bại'
      } finally {
        this.loadingPassword = false
      }
    },

    backToDashboard() {
      this.$router.replace('/sale')
    }
  }
}
</script>

<style scoped>
.profile-wrapper {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 20px;
}

.inner-profile {
  max-width: 600px;
  width: 100%;
  padding: 0;
}

.profile-title {
  font-size: 24px;
  font-weight: 700;
  color: #212529;
  margin-bottom: 8px;
}

.profile-subtitle {
  color: #6c757d;
  margin: 0;
  font-size: 14px;
}

/* Info Card */
.info-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px #ddd;
  border: 1px solid #e9ecef;
  overflow: hidden;
}

.card-header-custom {
  padding: 20px 24px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
}

.card-header-custom i {
  font-size: 18px;
  color: #007bff;
}

.card-header-custom h5 {
  font-weight: 600;
  color: #212529;
}

.card-body-custom {
  padding: 24px;
}

/* Form Controls */
.form-label-custom {
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.form-label-custom.require::after {
  content: '*';
  color: #dc3545;
  margin-left: 4px;
}

.form-control-custom {
  border-radius: 8px;
  border: 1px solid #dee2e6;
  padding: 10px 14px;
  font-size: 14px;
}

.form-control-custom:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
}

.form-control-custom:disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
}

.form-group {
  margin-bottom: 20px;
}

/* Buttons */
.btn-custom {
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
}

.btn-custom i {
  font-size: 14px;
}

/* Success Badge */
.success-badge {
  display: inline-flex;
  align-items: center;
  padding: 10px 16px;
  background: #d4edda;
  color: #155724;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
}

/* Action Group */
.action-group {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

/* Error Message */
.error-message {
  color: #dc3545;
  font-size: 13px;
  margin-top: 6px;
}

/* Responsive */
@media (max-width: 576px) {
  .profile-wrapper {
    padding: 20px 12px;
  }

  .action-group {
    flex-direction: column;
  }

  .action-group button {
    width: 100%;
  }
}
</style>
